import axios_api from '../../../utils/axios_api';

const BASE_URL = '/ai-qna/v1';

export const qnaApi = {
    // 1. 새 질문 생성
    ask: async (req) => {
        const response = await axios_api.post(`${BASE_URL}/ask`, req, {
            timeout: 20000
        });
        return response.data;
    },

    // 2. QnA 목록 조회
    // 'admin' viewMode는 백엔드 미지원 → 'company'로 매핑 (vw_qa_history_service 전체 반환)
    historyList: async (memberId, viewMode = 'personal') => {
        const apiViewMode = viewMode === 'admin' ? 'company' : viewMode;
        const response = await axios_api.post(`${BASE_URL}/history/list`, { memberId, viewMode: apiViewMode });
        return response.data;
    },

    // 2b. AI 관리자 질의현황 (회원·사업장 조인)
    adminHistoryList: async () => {
        const response = await axios_api.post(`${BASE_URL}/admin/history/list`, {}, { timeout: 20000 });
        return response.data;
    },

    // 3. QnA 삭제 (AI 알리미·일반)
    historyDelete: async (turnId) => {
        const response = await axios_api.delete(`${BASE_URL}/history/${turnId}`);
        return response.data;
    },

    // 3b. AI 관리자 질의현황 삭제 (R0 / 동일 사업장 R2)
    adminHistoryDelete: async (turnId) => {
        const response = await axios_api.delete(`${BASE_URL}/admin/history/${turnId}`);
        return response.data;
    },

    // 4. QnA 단건 원문 조회
    historyGet: async (req) => {
        const response = await axios_api.post(`${BASE_URL}/history/get`, req);
        return response.data;
    },

    categoriesList: async (req) => {
        const response = await axios_api.post(`${BASE_URL}/categories/list`, req);
        return response.data;
    },

    // 6. 자주 묻는 질문(FAQ) 목록 조회 (v2)
    getFaqList: async (page = 1, size = 8, category = '', keyword = '') => {
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('size', size);
        if (category && category !== '전체') params.append('category', category);
        if (keyword) params.append('keyword', keyword);

        const response = await axios_api.get(`${BASE_URL}/faq/list?${params.toString()}`);
        // [AiChatController 커스텀 응답 형식] { ok, message, data } — 표준 ResponseVO({ status, message, result }) 형식 아님.
        // 서버 응답 구조: { ok: true, message: "success", data: FaqPageResponseDto }
        // response.data.data는 내부 data 필드(FaqPageResponseDto: { items, total, ... })를 의도적으로 추출함.
        // FaqView.jsx에서 data.items, data.total 로 직접 접근함.
        return response.data.data;
    }
};
